import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ser-con-rimborso-amministrativo-select',
  templateUrl: './con-rimborso-amministrativo-select.component.html',
  styleUrl: './con-rimborso-amministrativo-select.component.scss'
})
export class ConRimborsoAmministrativoSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() readonly: boolean;
  @Input() label: string = 'assistenze.fields.conRimborsoAmministrativo';

  items: IS1InputSelectItem[] = [];

  constructor(private translateService: TranslateService) {

    this.loadItems();

    this.translateService.onLangChange.subscribe(changed => {
      this.loadItems();
    })

  }

  private loadItems() {
    this.items = [
      { code: null, label: this.translateService.instant("assistenze.fields.conRimborsoAmministrativoAll") },
      { code: true, label: this.translateService.instant("assistenze.fields.conRimborsoAmministrativoYes") },
      { code: false, label: this.translateService.instant("assistenze.fields.conRimborsoAmministrativoNo") },
    ];
  }

  ngOnInit(): void { }

}
